import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { CourseModuleModel } from '../../../models/course-module.model';
import { ApiRequestService } from '../../../shared/api-request.service';
import { UtilsService } from '../../../shared/utils.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-courses-modules-view',
  templateUrl: './courses-modules-view.component.html',
  styleUrls: ['./courses-modules-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CoursesModulesViewComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public module: CourseModuleModel,
    public route: ActivatedRoute,
    public router: Router,
    public app: AppService,
    private api: ApiRequestService,
    public utils: UtilsService
  ) {}
}
